import React, { Component } from 'react';
import { ContactsTable } from './Contacts/ContactsTable';
import { ResearcherDetails } from './Researcher/ResearcherDetails';
import { ResearcherForm } from './ResearcherForm';

export class EditResearcher extends Component {
    constructor(props) {
        super(props);

        this.state = {
            researcherId: this.getResearcherId()
        };
    }

    getResearcherId() {
        const params = new URLSearchParams(window.location.search);

        return params.get('id');
    }

    render() {
        return (
            <div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item" aria-current="page"><a href="/researchers">Researcher List</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Researcher</li>
                    </ol>
                </nav>
                <ResearcherDetails researcherId={this.state.researcherId} showTitle />
                <hr />
                <ContactsTable researcherId={this.state.researcherId} />
            </div>
        )
    }
}